import { render, staticRenderFns } from "./FlagSelect.vue?vue&type=template&id=424b7417"
import script from "./FlagSelect.vue?vue&type=script&lang=ts"
export * from "./FlagSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports